var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.867,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16V1.288A1.28 1.28 0 011.288 0h14.29a1.28 1.28 0 011.288 1.288V11.83a1.28 1.28 0 01-1.288 1.288H2.881zm.726-1.757l1.851-1.851h13a.56.56 0 00.562-.562V1.288a.56.56 0 00-.562-.562H1.288a.56.56 0 00-.562.562zm0-12.955z",
    fill: "#747474"
  })));
}
export default SvgReplyIcon;